import React from "react";
import Meta from "antd/lib/card/Meta";
import { Card } from "antd";
import { Link } from "umi";
import { formatWithCommas } from "@/utils/utils";
// @ts-ignore this import is correct
import styles from "../styles.less";
const DataCountCard = ({ loading, count, label, url }) => (React.createElement(Card, { className: styles.adminDashboardDataCountCard, loading: loading },
    React.createElement(Meta, { title: url ? (React.createElement(Link, { to: url, style: {
                color: "black",
                fontWeight: "bold",
                fontSize: 32,
            }, className: styles.adminDashboardDataCountCardNumberText }, formatWithCommas(count))) : (React.createElement("span", { style: {
                color: "black",
                fontWeight: "bold",
                fontSize: 32,
            }, className: styles.adminDashboardDataCountCardNumberText }, formatWithCommas(count))), description: React.createElement("span", { className: styles.adminDashboardDataCountCardLabelText }, label) })));
DataCountCard.defaultProps = {
    count: 0,
};
export default DataCountCard;
